import React, { FC } from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';
import styled from '../../../theme/styled';

const StyledImage = styled(Img)({
  maxWidth: '100%'
});

export const RemoteWorkImage: FC = () => {
  const data = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "homepage/cloud-insights.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    }
  `);
  return <StyledImage fluid={data.file.childImageSharp.fluid} alt="" />;
};
